(ns ui.editors.open-search.model
  (:require
   [common.schema.registry :as registry]
   [common.util :as cu]))

(def ^:private stage-entity-types
  #{:entity.type/stage
    :entity.type/opportunity-stage
    :entity.type/sales-opportunity-stage
    :entity.type/exit-opportunity-stage})

(defn- named-values-only?
  [entity-types]
  (every? #{:entity.type/named-value} entity-types))

(defn- pipeline-scoped?
  "True when the search offers only the records of one pipeline. These are the
   stages, and the named values of a pipeline attribute."
  [{:keys [entity-types named-value-attribute]}]
  (or (every? stage-entity-types entity-types)
      (and (named-values-only? entity-types)
           (registry/pipeline-attribute? named-value-attribute))))

(defn filter-terms
  "The OpenSearch filter terms of the search editor.

   A named-value picker never offers a value that is archived. An archived value
   has two forms. A pipeline attribute is archived for each pipeline, and the
   index document holds the pipelines where the value is active in
   `extras.pipeline`. Any other attribute is archived for all, and the document
   holds that in `extras.archived`. The `extras.archived` filter always applies
   to named values. The `extras.pipeline` filter applies when `pipeline-id` is
   known.

   A pipeline attribute with no `pipeline-id` has no pipeline filter. The caller
   must pass `:creation-pipeline-id` or a `:containing-entity` to get one.

   `field-filter-terms` are the terms of `:field/os-filter-terms-fn`."
  [{:keys [entity-types named-value-attribute pipeline-id field-filter-terms]
    :as   args}]
  (merge
   {}
   field-filter-terms
   (when named-value-attribute
     {"original.named-value/attribute.keyword" (cu/kw->str named-value-attribute)})
   (when (and named-value-attribute
              (named-values-only? entity-types))
     {"extras.archived" false})
   (when (and pipeline-id
              (pipeline-scoped? args))
     {"extras.pipeline" pipeline-id})))
